/* ============================================================================
   Unisex Size Selector — companion script (v7)
   Save as: assets/unisex-size-selector.js

   v7 : ZÉRO clignotement au changement de variante.
   Le thème remplace la fieldset par du HTML serveur ("Homme" par défaut).
   On corrige le genre AVANT insertion via un hook appelé depuis
   variant-picker.js (window.USSCorrectBeforeInsert), pendant que le nœud
   est encore détaché → la fieldset entre dans le DOM déjà dans le bon état.
   Le masquage CSS (uss-ready) reste comme filet de sécurité (chargement
   initial, ou si le hook n'est pas branché).
   ============================================================================ */

(function () {
  var STORAGE_KEY = 'uss-active-gender';

  // ---- Anti-flash CSS (filet de sécurité) ---------------------------------
  (function injectAntiFlashStyle() {
    if (document.getElementById('uss-anti-flash')) return;
    var style = document.createElement('style');
    style.id = 'uss-anti-flash';
    style.textContent =
      '.option-selector--unisex-size:not(.uss-ready) .uss-tabs,' +
      '.option-selector--unisex-size:not(.uss-ready) .option-selector__btns{visibility:hidden;}';
    (document.head || document.documentElement).appendChild(style);
  })();

  function getStoredGender() {
    try {
      var v = sessionStorage.getItem(STORAGE_KEY);
      return (v === 'men' || v === 'women') ? v : 'men';
    } catch (e) {
      return 'men';
    }
  }

  function setStoredGender(g) {
    try { sessionStorage.setItem(STORAGE_KEY, g); } catch (e) { /* noop */ }
  }

  function parseSize(value) {
    var match = value.match(
      /M(?:en'?s)?\s*([\d.]+H?)\s*\/\s*W(?:omen'?s)?\s*([\d.]+H?)/i
    );
    if (!match) return { men: value, women: value };
    return {
      men:   match[1].replace('H', '.5'),
      women: match[2].replace('H', '.5')
    };
  }

  function updateSpansForGender(fieldset, gender) {
    fieldset.querySelectorAll('.opt-btn').forEach(function (input) {
      var label = fieldset.querySelector('label[for="' + input.id + '"]');
      if (!label) return;
      var span = label.querySelector('span');
      if (!span) return;

      if (!span.dataset.ussOriginal) {
        span.dataset.ussOriginal = input.value;
      }

      var parsed = parseSize(span.dataset.ussOriginal);
      var newText = parsed[gender];
      if (span.textContent !== newText) {
        span.textContent = newText;
      }
    });
  }

  function applyGender(fieldset, gender) {
    if (fieldset.getAttribute('data-active-gender') !== gender) {
      fieldset.setAttribute('data-active-gender', gender);
    }
    fieldset.querySelectorAll('.uss-tab').forEach(function (t) {
      var isActive = t.dataset.gender === gender;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    updateSpansForGender(fieldset, gender);

    // Contenu corrigé → on révèle (fin de l'anti-flash).
    fieldset.classList.add('uss-ready');
  }

  function bindTabClicks(fieldset) {
    fieldset.querySelectorAll('.uss-tab').forEach(function (tab) {
      if (tab.dataset.ussBound === 'true') return;
      tab.dataset.ussBound = 'true';

      tab.addEventListener('click', function () {
        var gender = tab.dataset.gender;
        setStoredGender(gender);
        applyGender(fieldset, gender);
      });
    });
  }

  function correctFieldsetsWithin(node, gender) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches('.option-selector--unisex-size')) {
      applyGender(node, gender);
    }
    if (node.querySelectorAll) {
      node.querySelectorAll('.option-selector--unisex-size').forEach(function (fs) {
        applyGender(fs, gender);
      });
    }
  }

  // ---- Hook appelé depuis variant-picker.js AVANT insertion --------------
  // Corrige le(s) fieldset(s) unisexe(s) du nœud détaché avant qu'il n'entre
  // dans le DOM → aucun paint dans l'état "Homme", donc aucun clignotement.
  window.USSCorrectBeforeInsert = function (node) {
    correctFieldsetsWithin(node, getStoredGender());
  };

  function initSelector(fieldset) {
    applyGender(fieldset, getStoredGender());
    bindTabClicks(fieldset);
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('.option-selector--unisex-size')
      .forEach(initSelector);
  }

  // ---- Initial load --------------------------------------------------------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // ---- MutationObserver: filet si le hook n'a pas corrigé ----------------
  var observer = new MutationObserver(function (mutations) {
    var fieldsetsToFix = [];

    mutations.forEach(function (mut) {
      mut.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.option-selector--unisex-size')) {
          fieldsetsToFix.push(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.option-selector--unisex-size').forEach(function (fs) {
            fieldsetsToFix.push(fs);
          });
        }
      });
    });

    if (fieldsetsToFix.length > 0) {
      var gender = getStoredGender();
      fieldsetsToFix.forEach(function (fs) {
        applyGender(fs, gender);
        bindTabClicks(fs);
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // ---- Post-swap safety net ------------------------------------------------
  document.addEventListener('on:variant:change', function () {
    initAll();
  });
})();